import { useAppDispatch, useAppSelector } from 'src/reducers';
import { deleteRole } from '../../../../reducers/roles.reducer';
import { Role } from '../../../../models/user.model';
import Modal from '../../../atoms/modal/modal';
import Button from '../../../atoms/button/button';
import { closeModal } from '../../../../reducers/modal.reducer';
import Flex from '../../../atoms/flex/flex';
import Spinner from '../../../atoms/spinner/spinner';

type Props = {
  role: Role;
};
export const DeleteRoleModal = (props: Props) => {
  const { role } = props;
  const dispatch = useAppDispatch();
  const { loading } = useAppSelector(state => state.roles);

  const handleDeleteRole = () => {
    dispatch(deleteRole({ roleId: role.id }));
  };

  return (
    <>
      <Modal.Header />
      <Modal.Body>
        <>
          <div className="mb-1">
            Confermi di voler eliminare il profilo <strong>{role.name}</strong>?
          </div>
          <Flex container alignItems="center" gap={10}>
            <Button size="sm" mode="outline" color="black" rounded="rounded-sm" fullWidth onClick={() => dispatch(closeModal())}>
              Annulla
            </Button>
            <Button size="sm" mode="solid" color="black" rounded="rounded-sm" fullWidth onClick={handleDeleteRole}>
              {loading ? <Spinner color="white" /> : 'Elimina ruolo'}
            </Button>
          </Flex>
        </>
      </Modal.Body>
    </>
  );
};
